import { render } from "./TokenHistoryDetail.vue?vue&type=template&id=7925f615&ts=true"
import script from "./TokenHistoryDetail.vue?vue&type=script&lang=ts"
export * from "./TokenHistoryDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__